import { PropsWithChildren, useMemo } from 'react'
import {
  QueryCache,
  QueryClient,
  QueryClientProvider as TanStackQueryProvider,
} from '@tanstack/react-query'

const useQueryClient = () => {
  return useMemo(() => {
    const queryCache = new QueryCache({})
    return new QueryClient({
      queryCache,
      defaultOptions: {
        queries: {
          staleTime: Infinity,
          refetchOnWindowFocus: false,
        },
      },
    })
  }, [])
}

const QueryClientProvider = ({ children }: PropsWithChildren) => {
  const queryClient = useQueryClient()
  return <TanStackQueryProvider client={queryClient}>{children}</TanStackQueryProvider>
}

export default QueryClientProvider
